{
  "a11y": {
    "skipToContent": "تخطَّ إلى المحتوى",
    "dnd": {
      "instructions": "لالتقاط عنصر، اضغط مسافة أو Enter. استخدم مفاتيح الأسهم لتحريكه، ثم مسافة أو Enter لإفلاته، أو Escape للإلغاء.",
      "pickedUp": "تم التقاط {{name}}. الموضع {{position}} من {{total}}.",
      "over": "{{name}} الآن في الموضع {{position}} من {{total}}.",
      "dropped": "تم إفلات {{name}} في الموضع {{position}} من {{total}}.",
      "cancelled": "تم إلغاء نقل {{name}}."
    }
  },
  "nav": {
    "label": "التنقل الرئيسي",
    "lists": "القوائم",
    "categories": "الأقسام",
    "search": "بحث",
    "favorites": "المفضلة",
    "shared": "المشتركة",
    "profile": "الملف الشخصي",
    "settings": "الإعدادات",
    "notifications": "الإشعارات",
    "meals": "الوصفات",
    "archived": "الأرشيف",
    "sponsoredAdmin": "القوائم المميّزة",
    "accountMenu": "قائمة الحساب",
    "catalogAdmin": "عناصر الكتالوج",
    "admin": "الإدارة"
  },
  "common": {
    "back": "رجوع",
    "cancel": "إلغاء",
    "close": "إغلاق",
    "dismiss": "إخفاء",
    "loadMore": "عرض المزيد",
    "loading": "جارٍ التحميل…",
    "reload": "إعادة التحميل",
    "retry": "حاول مجددًا",
    "save": "حفظ",
    "undo": "تراجع",
    "pagination": "الصفحات",
    "previous": "السابق",
    "next": "التالي",
    "pageOf": "الصفحة {{page}} من {{pages}}"
  },
  "auth": {
    "tagline": "قوائم تسوّق تشاركها مع من تتسوّق لأجلهم.",
    "sample": {
      "milk": "حليب",
      "bread": "خبز",
      "tomatoes": "طماطم",
      "coffee": "قهوة"
    },
    "backToLogin": "العودة إلى تسجيل الدخول",
    "sessionExpired": "تم تسجيل خروجك. سجّل الدخول مجددًا للمتابعة.",
    "passwordHint": "{{min}} أحرف على الأقل. الجملة القصيرة خيار جيد.",
    "fields": {
      "email": "البريد الإلكتروني",
      "password": "كلمة المرور",
      "displayName": "اسمك",
      "newPassword": "كلمة المرور الجديدة",
      "confirmPassword": "تأكيد كلمة المرور الجديدة",
      "country": "الدولة (اختياري)",
      "countryHint": "نستخدمها لنعرض لك عروض المتاجر القريبة منك. يمكنك تغييرها من ملفك الشخصي.",
      "countryNone": "أفضّل عدم الإفصاح",
      "useLocation": "استخدام موقعي",
      "locateFailed": "تعذّر تحديد بلدك من موقعك. اختره من القائمة."
    },
    "errors": {
      "email": "أدخل بريدًا إلكترونيًا صحيحًا.",
      "passwordRequired": "أدخل كلمة المرور.",
      "passwordLength": "استخدم {{min}} أحرف على الأقل.",
      "passwordWeak": "كلمة المرور هذه سهلة التخمين. جرّب عبارة أطول.",
      "passwordMismatch": "كلمتا المرور غير متطابقتين.",
      "displayName": "أدخل اسمك."
    },
    "login": {
      "title": "تسجيل الدخول",
      "intro": "أهلًا بعودتك. قوائمك بانتظارك.",
      "submit": "تسجيل الدخول",
      "forgot": "نسيت كلمة المرور؟",
      "noAccount": "جديد على Lista؟",
      "createAccount": "أنشئ حسابًا",
      "invalid": "البريد الإلكتروني وكلمة المرور غير متطابقين. تحقّق منهما وحاول مجددًا."
    },
    "register": {
      "title": "أنشئ حسابك",
      "intro": "مجاني وجاهز خلال دقيقة.",
      "submit": "إنشاء الحساب",
      "haveAccount": "لديك حساب بالفعل؟",
      "checkEmailTitle": "تحقّق من بريدك",
      "checkEmail": "أرسلنا رابطًا إلى {{email}}. افتحه لتأكيد عنوانك ثم سجّل الدخول.",
      "goToLogin": "الذهاب إلى تسجيل الدخول"
    },
    "forgot": {
      "title": "إعادة تعيين كلمة المرور",
      "intro": "أدخل بريدك وسنرسل لك رابطًا لتعيين كلمة مرور جديدة.",
      "submit": "إرسال الرابط",
      "sent": "إذا كان لـ {{email}} حساب، فرابط إعادة التعيين في طريقه إليك. الرابط صالح لمدة 30 دقيقة."
    },
    "reset": {
      "title": "تعيين كلمة مرور جديدة",
      "intro": "اختر كلمة مرور جديدة. سيتم تسجيل خروجك من أجهزتك الأخرى.",
      "submit": "حفظ كلمة المرور",
      "done": "تم تغيير كلمة المرور. سجّل الدخول بكلمة المرور الجديدة.",
      "invalid": "انتهت صلاحية رابط إعادة التعيين أو سبق استخدامه.",
      "requestNew": "اطلب رابطًا جديدًا"
    },
    "verify": {
      "title": "تأكيد البريد الإلكتروني",
      "checking": "جارٍ التحقق من الرابط…",
      "done": "تم تأكيد بريدك. يمكنك الآن قبول القوائم المشتركة.",
      "invalid": "انتهت صلاحية رابط التأكيد أو سبق استخدامه.",
      "continue": "المتابعة إلى قوائمك"
    }
  },
  "errors": {
    "generic": "حدث خطأ ما. حاول مجددًا.",
    "network": "أنت غير متصل أو يتعذّر الوصول إلى الخادم. تحقّق من اتصالك وحاول مجددًا.",
    "loadFailed": "تعذّر التحميل",
    "crashTitle": "توقفت هذه الشاشة عن العمل",
    "crashBody": "أعد تحميل التطبيق للمتابعة. قوائمك محفوظة.",
    "newVersion": "يتوفر إصدار جديد",
    "newVersionBody": "أعد التحميل للحصول على أحدث إصدار من Lista.",
    "codes": {
      "VALIDATION_FAILED": "بعض البيانات غير صحيحة. راجع النموذج وحاول مجددًا.",
      "UNAUTHENTICATED": "سجّل الدخول للمتابعة.",
      "TOKEN_EXPIRED": "انتهت جلستك. سجّل الدخول مجددًا.",
      "INVALID_CREDENTIALS": "البريد الإلكتروني وكلمة المرور غير متطابقين.",
      "EMAIL_NOT_VERIFIED": "أكّد بريدك الإلكتروني أولًا.",
      "FORBIDDEN": "ليست لديك صلاحية لهذا الإجراء.",
      "LIST_NOT_FOUND": "هذه القائمة غير موجودة أو غير مشتركة معك.",
      "INSUFFICIENT_LIST_ROLE": "صلاحيتك على هذه القائمة لا تسمح بذلك.",
      "LIST_ARCHIVED": "هذه القائمة مؤرشفة. ألغِ الأرشفة لإجراء تغييرات.",
      "LIST_DELETED": "تم حذف هذه القائمة.",
      "LIST_LIMIT": "وصلت إلى الحد الأقصى وهو 200 قائمة. احذف قائمة لإنشاء أخرى.",
      "VERSION_MISMATCH": "غيّر شخص آخر هذه القائمة. حمّلنا أحدث نسخة.",
      "PRECONDITION_REQUIRED": "حدّث القائمة وحاول مجددًا.",
      "LIST_ITEM_LIMIT": "تتسع القائمة لـ 500 عنصر كحد أقصى.",
      "QUANTITY_LIMIT": "لا يمكن أن تتجاوز الكمية 9999.",
      "STALE_POSITION": "تغيّرت القائمة. حدّثها وحاول مجددًا.",
      "CUSTOM_ITEM_LIMIT": "وصلت إلى الحد الأقصى للعناصر الخاصة.",
      "FAVORITE_LIMIT": "يمكنك إضافة 1000 عنصر مفضّل كحد أقصى.",
      "LIST_MEMBER_LIMIT": "يمكن مشاركة القائمة مع 50 شخصًا كحد أقصى.",
      "ALREADY_MEMBER": "هذا الشخص لديه وصول إلى القائمة بالفعل.",
      "ALREADY_INVITED": "تمت دعوة هذا الشخص بالفعل.",
      "CANNOT_SHARE_WITH_SELF": "هذا بريدك الإلكتروني.",
      "CANNOT_CHANGE_OWNER_ROLE": "لا يمكن تغيير صلاحية المالك.",
      "CANNOT_REMOVE_OWNER": "لا يمكن إزالة المالك.",
      "OWNER_CANNOT_LEAVE": "لا يمكن للمالك المغادرة. احذف القائمة بدلًا من ذلك.",
      "MEMBER_NOT_FOUND": "هذا الشخص لم يعد في القائمة.",
      "INVITATION_INVALID": "انتهت صلاحية هذه الدعوة أو سبق استخدامها.",
      "INVITATION_EMAIL_MISMATCH": "أُرسلت هذه الدعوة إلى بريد إلكتروني مختلف.",
      "RATE_LIMITED": "محاولات كثيرة. انتظر قليلًا ثم حاول مجددًا.",
      "AI_UNAVAILABLE": "قراءة الصور غير متاحة حاليًا. حاول بعد دقيقة.",
      "PDF_UNAVAILABLE": "تصدير PDF غير متاح حاليًا. حاول بعد دقيقة.",
      "NOT_FOUND": "لم نجد ما تبحث عنه.",
      "CONFLICT": "يتعارض هذا مع شيء موجود بالفعل.",
      "INTERNAL_ERROR": "حدث خطأ من جهتنا. حاول مجددًا.",
      "SHARE_NOT_FOUND": "هذه المشاركة لم تعد متاحة.",
      "CUISINE_NOT_FOUND": "هذا المطبخ غير موجود.",
      "MEAL_NOT_FOUND": "هذه الوصفة غير موجودة.",
      "SHARE_LINK_NOT_FOUND": "هذا الرابط لم يعد صالحًا.",
      "SHARE_LINK_LIMIT": "وصلت هذه القائمة إلى الحد الأقصى من الروابط النشطة. أوقف أحدها أولًا."
    }
  },
  "dashboard": {
    "title": "قوائمي",
    "filterLabel": "عرض",
    "filters": {
      "all": "الكل",
      "owned": "قوائمي",
      "sharing": "قوائم أشاركها",
      "shared": "مشتركة معي",
      "archived": "المؤرشفة"
    },
    "sortLabel": "الترتيب",
    "sort": {
      "custom": "مخصص",
      "updatedAt": "تاريخ التعديل",
      "createdAt": "تاريخ الإنشاء",
      "name": "الاسم"
    },
    "empty": {
      "all": {
        "title": "لا توجد قوائم بعد",
        "body": "أنشئ قائمة لتسوّق الأسبوع أو لحفلة أو لأي شيء تحتاج شراءه."
      },
      "owned": {
        "title": "لم تنشئ أي قائمة",
        "body": "أنشئ قائمة وشاركها عندما تكون جاهزًا."
      },
      "sharing": {
        "title": "لا تشارك أي قائمة بعد",
        "body": "شارك إحدى قوائمك وستظهر هنا."
      },
      "shared": {
        "title": "لم يشارك أحد قائمة معك بعد",
        "body": "عندما يشارك أحدهم قائمة معك، ستظهر هنا."
      },
      "archived": {
        "title": "لا توجد قوائم مؤرشفة",
        "body": "أرشِف القوائم التي انتهيت منها لتبقى هذه الصفحة مرتبة."
      }
    }
  },
  "lists": {
    "untitled": "قائمة بلا عنوان",
    "new": "قائمة جديدة",
    "create": "إنشاء القائمة",
    "createTitle": "قائمة جديدة",
    "editTitle": "تعديل القائمة",
    "name": "اسم القائمة",
    "namePlaceholder": "مثلًا: مقاضي الأسبوع",
    "color": "اللون",
    "open": "فتح",
    "edit": "تعديل",
    "archive": "أرشفة",
    "unarchive": "إلغاء الأرشفة",
    "delete": "حذف",
    "actionsFor": "إجراءات {{name}}",
    "created": "تم إنشاء {{name}}",
    "saved": "تم حفظ القائمة",
    "archived": "تمت أرشفة {{name}}",
    "unarchived": "تم إلغاء أرشفة {{name}}",
    "deleted": "تم حذف {{name}}",
    "changedElsewhere": "غيّر شخص آخر هذه القائمة. حمّلنا أحدث نسخة، حاول مجددًا.",
    "deleteConfirm": {
      "title": "حذف {{name}}؟",
      "body": "سيفقد كل من تشاركهم القائمة الوصول إليها. لا يمكن التراجع عن ذلك من التطبيق."
    },
    "errors": {
      "nameRequired": "اكتب اسمًا للقائمة."
    },
    "noItemsYet": "لا توجد عناصر بعد",
    "allDone": "تم شراء كل شيء",
    "remaining_zero": "عنصر متبقٍ",
    "remaining_one": "عنصر متبقٍ",
    "remaining_two": "عنصران متبقيان",
    "remaining_few": "عناصر متبقية",
    "remaining_many": "عنصرًا متبقيًا",
    "remaining_other": "عنصر متبقٍ",
    "items_zero": "لا عناصر",
    "items_one": "عنصر واحد",
    "items_two": "عنصران",
    "items_few": "{{formatted}} عناصر",
    "items_many": "{{formatted}} عنصرًا",
    "items_other": "{{formatted}} عنصر",
    "itemCount": "العناصر",
    "lastUpdated": "آخر تعديل",
    "sharing": "المشاركة",
    "status": "الحالة",
    "progressLabel": "ما تم شراؤه",
    "sharedWith_zero": "غير مشتركة",
    "sharedWith_one": "مشتركة مع شخص واحد",
    "sharedWith_two": "مشتركة مع شخصين",
    "sharedWith_few": "مشتركة مع {{count}} أشخاص",
    "sharedWith_many": "مشتركة مع {{count}} شخصًا",
    "sharedWith_other": "مشتركة مع {{count}} شخص",
    "sharedBy": "من {{name}}",
    "archivedBadge": "مؤرشفة",
    "updated": "عُدّلت {{when}}",
    "dragHandle": "نقل {{name}}",
    "previewLabel": "عناصر القائمة",
    "previewMore": "+{{formatted}} أخرى",
    "pin": "تثبيت في الأعلى",
    "duplicate": "تكرار القائمة",
    "copyOf": "نسخة من {{name}}",
    "duplicated": "تم إنشاء {{name}}",
    "shareName": "مشاركة {{name}}",
    "pinName": "تثبيت {{name}}",
    "unpinName": "إلغاء تثبيت {{name}}",
    "unpin": "إلغاء التثبيت",
    "pinned": "تم تثبيت {{name}}",
    "unpinned": "تم إلغاء تثبيت {{name}}",
    "pinnedBadge": "مثبتة"
  },
  "list": {
    "titleLabel": "اسم القائمة",
    "editTitle": "انقر لإعادة التسمية",
    "editTitleName": "إعادة تسمية {{name}}",
    "collapseCategory": "طيّ {{name}}",
    "expandCategory": "توسيع {{name}}",
    "addItem": "إضافة عنصر",
    "share": "مشاركة",
    "private": "لك وحدك",
    "sharedBy": {
      "EDITOR": "قائمة {{name}}. يمكنك تعديلها.",
      "VIEWER": "قائمة {{name}}. يمكنك عرضها فقط.",
      "OWNER": "قائمتك"
    },
    "tally_zero": "متبقٍ من {{total}}",
    "tally_one": "متبقٍ من {{total}}",
    "tally_two": "متبقيان من {{total}}",
    "tally_few": "متبقية من {{total}}",
    "tally_many": "متبقيًا من {{total}}",
    "tally_other": "متبقٍ من {{total}}",
    "tallyEmpty": "عناصر - أضف أول عنصر",
    "archivedBanner": "هذه القائمة مؤرشفة وللقراءة فقط.",
    "viewerBanner": "يمكنك عرض هذه القائمة. اطلب من المالك صلاحية التعديل لتغييرها.",
    "findPlaceholder": "ابحث في هذه القائمة",
    "findLabel": "ابحث عن عنصر في هذه القائمة",
    "categoryFilter": "التصفية حسب القسم",
    "allCategories": "الكل",
    "otherCategory": "أخرى",
    "boughtSection_zero": "تم شراؤه ({{count}})",
    "boughtSection_one": "تم شراؤه ({{count}})",
    "boughtSection_two": "تم شراؤه ({{count}})",
    "boughtSection_few": "تم شراؤه ({{count}})",
    "boughtSection_many": "تم شراؤه ({{count}})",
    "boughtSection_other": "تم شراؤه ({{count}})",
    "everythingBought": "تم شراء كل ما في هذه القائمة.",
    "noMatches": "لا توجد عناصر مطابقة",
    "empty": {
      "title": "هذه القائمة فارغة",
      "body": "ابحث عن العناصر أو تصفّح الأقسام لإضافتها.",
      "readOnly": "لا يوجد ما يُشترى بعد."
    },
    "notFound": {
      "title": "القائمة غير موجودة",
      "body": "ربما حُذفت، أو لم تعد مشتركة معك.",
      "action": "الذهاب إلى قوائمي"
    },
    "order": {
      "label": "عرض العناصر",
      "category": "حسب القسم",
      "custom": "مخصص",
      "createdAt": "تاريخ الإضافة",
      "updatedAt": "تاريخ التعديل",
      "dragHint": "اسحب العناصر من مقابضها لترتيب القائمة."
    },
    "view": {
      "label": "العرض",
      "rows": "صفوف",
      "tiles": "مربعات"
    }
  },
  "items": {
    "addTitle": "إضافة عناصر",
    "searchPlaceholder": "حليب، خبز، طماطم…",
    "searchLabel": "ابحث عن عناصر لإضافتها",
    "browseLabel": "تصفّح",
    "quickAdd": "إضافة {{name}}",
    "addCustom": "إضافة «{{name}}»",
    "addCustomDetail": "كعنصر جديد",
    "newItemNote": "سيُحفظ في عناصرك لتجده لاحقًا.",
    "onList": "في القائمة: {{quantity}}",
    "backToResults": "رجوع",
    "allCategories": "كل الأقسام",
    "quantity": "الكمية",
    "unit": "الوحدة",
    "note": "ملاحظات",
    "notePlaceholder": "العلامة التجارية، الحجم، درجة النضج…",
    "decrease": "إنقاص الكمية",
    "increase": "زيادة الكمية",
    "errors": {
      "quantity": "أدخل رقمًا بين 0.001 و9999."
    },
    "addToList": "إضافة إلى القائمة",
    "addToListTitle": "إضافة {{name}}",
    "chooseList": "القائمة",
    "added": "تمت إضافة {{name}}",
    "addedTo": "تمت إضافة {{name}} إلى {{list}}",
    "addedToMany": "أُضيف {{name}} إلى القوائم المحددة ({{count}})",
    "targets": {
      "addTo": "أضف إلى",
      "label": "أضف إلى: {{lists}}. اختر القوائم",
      "choose": "اختر القوائم",
      "many": "{{name}} +{{count}}",
      "legend": "أضف العناصر إلى هذه القوائم",
      "noneSelected": "اختر قائمة واحدة على الأقل للإضافة إليها",
      "failed": "تعذّرت الإضافة إلى {{list}}: {{reason}}"
    },
    "saved": "تم حفظ {{name}}",
    "removed": "تمت إزالة {{name}}",
    "remove": "إزالة",
    "removeName": "إزالة {{name}} من هذه القائمة",
    "removeConfirm": {
      "title": "إزالة {{name}}؟",
      "body": "سيختفي من هذه القائمة لدى الجميع."
    },
    "bought": "تم الشراء",
    "boughtBy": "اشتراه {{name}}",
    "readOnly": "يمكنك عرض هذا العنصر دون تغييره.",
    "markBought": "تعليم {{name}}، {{quantity}}، كمُشترى",
    "markNotBought": "تعليم {{name}}، {{quantity}}، كغير مُشترى",
    "openItem": "تعديل {{name}}",
    "noWritableLists": {
      "title": "لا توجد قائمة للإضافة إليها",
      "body": "أنشئ قائمة أولًا، أو اطلب صلاحية التعديل على قائمة مشتركة.",
      "action": "الذهاب إلى قوائمي"
    },
    "recent": {
      "tab": "الأخيرة",
      "emptyTitle": "لا شيء هنا بعد",
      "emptyBody": "تظهر هنا العناصر التي تضيفها إلى أي قائمة، الأحدث أولًا.",
      "title": "المستخدمة مؤخرًا"
    },
    "dragHandle": "نقل {{name}}"
  },
  "catalog": {
    "categoriesTitle": "الأقسام",
    "itemCount_zero": "لا عناصر",
    "itemCount_one": "عنصر واحد",
    "itemCount_two": "عنصران",
    "itemCount_few": "{{count}} عناصر",
    "itemCount_many": "{{count}} عنصرًا",
    "itemCount_other": "{{count}} عنصر",
    "emptyCategory": "لا توجد عناصر في هذا القسم بعد",
    "addToList": "إضافة إلى قائمة",
    "addNameToList": "إضافة {{name}} إلى قائمة",
    "addNameToTargets": "أضف {{name}} إلى القوائم المحددة",
    "myItem": "عنصري"
  },
  "search": {
    "title": "بحث",
    "placeholder": "ابحث بالعربية أو الإنجليزية",
    "label": "البحث عن عناصر",
    "categories": "أقسام مطابقة",
    "prompt": {
      "title": "ابحث عن أي شيء تريد شراءه",
      "body": "اكتب حرفين على الأقل. الأخطاء الإملائية البسيطة لا بأس بها."
    },
    "noResults": {
      "title": "لا نتائج لـ «{{q}}»",
      "body": "تحقّق من الكتابة، أو أضفه كعنصر جديد من داخل القائمة."
    }
  },
  "favorites": {
    "title": "المفضلة",
    "searchPlaceholder": "ابحث في المفضلة",
    "searchLabel": "ابحث في عناصرك المفضلة",
    "noMatches": "لا توجد عناصر مفضلة تطابق «{{q}}»",
    "add": "إضافة إلى المفضلة",
    "remove": "إزالة من المفضلة",
    "addName": "إضافة {{name}} إلى المفضلة",
    "removeName": "إزالة {{name}} من المفضلة",
    "added": "أُضيف {{name}} إلى المفضلة",
    "removed": "أُزيل {{name}} من المفضلة",
    "isFavorite": "مفضّل",
    "discontinued": "لم يعد في الكتالوج",
    "empty": {
      "title": "لا توجد عناصر مفضلة بعد",
      "body": "اضغط النجمة على أي عنصر ليبقى هنا.",
      "action": "تصفّح الأقسام",
      "inPanel": "ضع نجمة على ما تشتريه كثيرًا وسيظهر هنا."
    }
  },
  "shared": {
    "title": "القوائم المشتركة",
    "withMe": "مشتركة معي",
    "byMe": "قوائم أشاركها",
    "emptyWithMe": {
      "title": "لم يشارك أحد قائمة معك بعد",
      "body": "عندما يشارك أحدهم قائمة معك، ستظهر هنا."
    },
    "emptyByMe": {
      "title": "لا تشارك أي قائمة",
      "body": "افتح قائمة واختر «مشاركة» لدعوة الآخرين."
    },
    "pendingTitle": "بانتظار ردّك",
    "pendingHint": "اقبل القائمة لتبدأ استخدامها. حتى ذلك الحين لا يمكنك فتحها.",
    "pendingBadge": "بانتظار القبول",
    "pendingBy": "شاركك {{name}} هذه القائمة",
    "pendingRole": "صلاحية: {{role}}",
    "accept": "قبول",
    "acceptName": "قبول {{name}}",
    "accepting": "جارٍ القبول…",
    "acceptedToast": "انضممت إلى {{name}}",
    "pendingLoadFailed": "تعذّر تحميل المشاركات المعلّقة",
    "decline": "رفض",
    "declining": "جارٍ الرفض…",
    "declinedToast": "رفضت {{name}}"
  },
  "sharing": {
    "title": "مشاركة {{name}}",
    "addPeople": "إضافة أشخاص",
    "emailPlaceholder": "البريد الإلكتروني",
    "permission": "الصلاحية",
    "permissionFor": "صلاحية {{name}}",
    "add": "إضافة",
    "addHint": "من لديه حساب في Lista يصله طلب عليه قبوله، والآخرون تصلهم دعوة بالبريد.",
    "added": "أُرسل طلب المشاركة إلى {{email}}",
    "invited": "أُرسلت الدعوة إلى {{email}}",
    "people_zero": "لا أحد",
    "people_one": "شخص واحد",
    "people_two": "شخصان",
    "people_few": "{{count}} أشخاص",
    "people_many": "{{count}} شخصًا",
    "people_other": "{{count}} شخص",
    "you": "أنت",
    "ownerSince": "المالك منذ {{date}}",
    "sharedOn": "شُورِكت في {{date}}",
    "invitedOn": "دُعي في {{date}}، تنتهي في {{expires}}",
    "pending": "بانتظار الانضمام",
    "remove": "إزالة",
    "removeName": "إزالة {{name}}",
    "removed": "تمت إزالة {{name}}",
    "removeConfirm": {
      "title": "إزالة {{name}}؟",
      "body": "سيفقد الوصول إلى {{list}}."
    },
    "leave": "مغادرة القائمة",
    "left": "غادرت {{name}}",
    "leaveConfirm": {
      "title": "مغادرة {{name}}؟",
      "body": "ستحتاج إلى دعوة جديدة لرؤية هذه القائمة مجددًا."
    },
    "revoke": "إلغاء دعوة {{email}}",
    "revoked": "أُلغيت دعوة {{email}}",
    "roleChanged": "تم تحديث صلاحية {{name}}",
    "rolesHelp": "المحررون يضيفون العناصر ويحذفونها ويغيّرون الكميات ويعلّمونها كمُشتراة ويضيفون الملاحظات. المشاهدون يطّلعون فقط.",
    "invitationTitle": "لديك دعوة إلى قائمة",
    "invitationIntro": "شاركك أحدهم قائمة تسوّق على Lista.",
    "acceptInvitation": "قبول الدعوة",
    "accepted": "انضممت إلى القائمة",
    "loginToAccept": "سجّل الدخول لقبول الدعوة",
    "registerToAccept": "أنشئ حسابًا لقبول الدعوة",
    "acceptErrors": {
      "notVerified": "أكّد بريدك الإلكتروني أولًا، ستجد الرابط في صندوق الوارد.",
      "mismatch": "أُرسلت هذه الدعوة إلى بريد مختلف. سجّل الدخول بذلك الحساب.",
      "invalid": "انتهت صلاحية هذه الدعوة أو أُلغيت أو سبق استخدامها."
    },
    "columns": {
      "user": "المستخدم",
      "permission": "الصلاحية",
      "shared": "تاريخ المشاركة",
      "actions": "الإجراءات"
    },
    "pendingBadge": "بانتظار القبول",
    "expires": "تنتهي الدعوة {{date}}",
    "revokeShort": "إلغاء الدعوة",
    "revokeConfirm": {
      "title": "إلغاء الدعوة المرسلة إلى {{email}}؟",
      "body": "سيتوقف الرابط المرسل في بريده عن العمل."
    },
    "roleHelp": {
      "OWNER": "وصول كامل: يعدّل القائمة وعناصرها والأشخاص والصلاحيات، ويؤرشفها أو يحذفها.",
      "EDITOR": "يضيف العناصر ويحذفها، ويغيّر الكميات، ويعلّمها كمُشتراة، ويضيف الملاحظات.",
      "VIEWER": "يطّلع على القائمة وعناصرها وكمياتها، ولا يمكنه تغيير أي شيء."
    },
    "whoHasAccess": "من لديه صلاحية الوصول",
    "link": {
      "heading": "المشاركة برابط",
      "hint": "أي شخص لديه الرابط يمكنه عرض هذه القائمة (للقراءة فقط) دون حساب. يمكنك إيقاف الرابط في أي وقت.",
      "expiry": "ينتهي الرابط بعد",
      "days_zero": "{{count}} يوم",
      "days_one": "يوم واحد",
      "days_two": "يومان",
      "days_few": "{{count}} أيام",
      "days_many": "{{count}} يومًا",
      "days_other": "{{count}} يوم",
      "create": "إنشاء رابط",
      "created": "تم إنشاء الرابط",
      "active": "الروابط النشطة",
      "none": "لا توجد روابط نشطة بعد.",
      "status": {
        "ACTIVE": "نشط",
        "EXPIRED": "منتهٍ"
      },
      "expires": "ينتهي {{date}}",
      "lastViewed": "آخر عرض {{date}}",
      "neverViewed": "لم يُعرض بعد",
      "copy": "نسخ الرابط",
      "copied": "تم نسخ الرابط",
      "whatsapp": "واتساب",
      "telegram": "تيليغرام",
      "email": "البريد الإلكتروني",
      "share": "مشاركة…",
      "more": "خيارات المشاركة",
      "revoke": "إيقاف الرابط",
      "revokeConfirm": {
        "title": "إيقاف هذا الرابط؟",
        "body": "لن يتمكن من لديهم الرابط من فتح القائمة بعد الآن."
      },
      "revoked": "تم إيقاف الرابط",
      "shareText": "{{name}} - قائمة تسوق على ليستا",
      "emailSubject": "{{name}} - قائمة تسوق"
    }
  },
  "roles": {
    "OWNER": "المالك",
    "EDITOR": "يمكنه التعديل",
    "VIEWER": "يمكنه العرض"
  },
  "export": {
    "pdf": "PDF",
    "downloadPdf": "تنزيل PDF",
    "sharePdf": "مشاركة PDF",
    "downloaded": "تم تنزيل ملف PDF"
  },
  "profile": {
    "title": "الملف الشخصي",
    "verified": "مؤكَّد",
    "unverified": "غير مؤكَّد",
    "verifyHint": "ابحث في بريدك عن رابط التأكيد. تحتاج إلى بريد مؤكَّد لقبول القوائم المشتركة.",
    "memberSince": "عضو منذ {{date}}",
    "details": "بياناتك",
    "saved": "تم حفظ الملف الشخصي",
    "sessions": "الأجهزة المسجّل دخولها",
    "sessionsHint": "سجّل الخروج من هنا، أو من كل الأجهزة إذا فقدت هاتفك.",
    "signOut": "تسجيل الخروج",
    "signOutAll": {
      "button": "الخروج من كل الأجهزة",
      "title": "تسجيل الخروج من كل الأجهزة؟",
      "body": "ستحتاج إلى تسجيل الدخول مجددًا على كل هاتف وحاسوب.",
      "confirm": "الخروج من كل الأجهزة"
    },
    "goToSettings": "اللغة والمظهر وإعدادات التطبيق",
    "password": {
      "title": "كلمة المرور",
      "intro": "تغيير كلمة المرور يسجّل خروجك من جميع الأجهزة الأخرى.",
      "current": "كلمة المرور الحالية",
      "submit": "تغيير كلمة المرور",
      "changed": "تم تغيير كلمة المرور وتسجيل الخروج من الأجهزة الأخرى.",
      "wrongCurrent": "كلمة المرور الحالية غير صحيحة.",
      "mustDiffer": "اختر كلمة مرور مختلفة عن الحالية."
    },
    "location": {
      "title": "موقعك",
      "hint": "يُستخدم لاقتراح عناصر مناسبة لبلدك وعرض القوائم المميّزة القريبة منك.",
      "country": "الدولة",
      "none": "غير محدد",
      "city": "المدينة",
      "cityPlaceholder": "مثال: الرياض"
    },
    "verifyTitle": "أكّد بريدك الإلكتروني",
    "verifyResend": "إعادة إرسال رسالة التأكيد",
    "verifyResendAgain": "إرسال مرة أخرى",
    "verifySent": "أرسلنا رابط تأكيد جديدًا إلى {{email}}. لم يعد الرابط السابق صالحًا."
  },
  "settings": {
    "title": "الإعدادات",
    "switchLanguage": "English",
    "switchToDark": "التبديل إلى الوضع الداكن",
    "switchToLight": "التبديل إلى الوضع الفاتح",
    "saved": "تم حفظ الإعدادات",
    "language": "اللغة",
    "theme": "المظهر",
    "themes": {
      "SYSTEM": "حسب الجهاز",
      "LIGHT": "فاتح",
      "DARK": "داكن"
    },
    "units": "الوحدات",
    "unitsHint": "نظام القياس الذي تفضّله.",
    "unitSystems": {
      "METRIC": "متري (كغ، لتر)",
      "IMPERIAL": "إمبراطوري (رطل، أونصة)"
    },
    "app": "التطبيق",
    "offlineHint": "القوائم التي فتحتها تبقى متاحة للقراءة دون اتصال. التغييرات تحتاج إلى اتصال وتُرسل عند عودته ما دام Lista مفتوحًا.",
    "install": "تثبيت Lista",
    "installed": "Lista مثبّت على هذا الجهاز.",
    "installIos": "على iPhone أو iPad: اضغط «مشاركة» ثم «إضافة إلى الشاشة الرئيسية».",
    "installBrowser": "استخدم قائمة المتصفح لتثبيت Lista أو إضافته إلى الشاشة الرئيسية.",
    "data": {
      "title": "الخصوصية وبياناتك",
      "intro": "اطّلع على كيفية تعاملنا مع بياناتك، وغيّر خيارات ملفات تعريف الارتباط، ونزّل نسخة من كل ما نحتفظ به عنك، أو احذف حسابك.",
      "download": "تنزيل بياناتي",
      "downloaded": "تم تنزيل بياناتك",
      "delete": "حذف الحساب",
      "deleteTitle": "هل تريد حذف حسابك؟",
      "consequenceLists_one": "ستُحذف القائمة التي تملكها.",
      "consequenceLists_other": "ستُحذف القوائم التي تملكها وعددها {{count}}.",
      "consequenceShared_one": "{{count}} منها مشتركة: سيُبلغ أعضاؤها بحذفها.",
      "consequenceShared_other": "{{count}} منها مشتركة: سيُبلغ أعضاؤها بحذفها.",
      "consequenceData": "ستُحذف مفضلتك وعناصرك المخصصة وخطط وجباتك وإشعاراتك.",
      "consequenceOthers": "تبقى العناصر التي أضفتها إلى قوائم الآخرين في تلك القوائم.",
      "irreversible": "لا يمكن التراجع عن ذلك.",
      "password": "أدخل كلمة المرور للتأكيد",
      "passwordRequired": "أدخل كلمة المرور",
      "wrongPassword": "كلمة المرور غير صحيحة",
      "deleteConfirm": "حذف حسابي",
      "deleted": "تم حذف حسابك، وأرسلنا إليك رسالة تأكيد."
    }
  },
  "pwa": {
    "offline": "أنت غير متصل. نعرض البيانات المحفوظة، وتُرسل التغييرات عند عودة الاتصال.",
    "offlineReady": "Lista جاهز للعمل دون اتصال",
    "updateAvailable": "يتوفر إصدار جديد من Lista",
    "reload": "إعادة التحميل"
  },
  "notFound": {
    "title": "الصفحة غير موجودة",
    "body": "قد يكون الرابط معطّلًا أو نُقلت الصفحة.",
    "action": "الذهاب إلى قوائمي"
  },
  "colors": {
    "default": "سادة",
    "red": "أحمر",
    "orange": "برتقالي",
    "yellow": "أصفر",
    "green": "أخضر",
    "teal": "أزرق مخضر",
    "blue": "أزرق",
    "indigo": "نيلي",
    "purple": "بنفسجي",
    "pink": "وردي",
    "brown": "بني",
    "gray": "رمادي"
  },
  "units": {
    "short": {
      "PIECE": "قطعة",
      "KG": "كغ",
      "G": "غ",
      "LB": "رطل",
      "OZ": "أونصة",
      "L": "لتر",
      "ML": "مل",
      "PACK": "عبوة",
      "DOZEN": "دزينة",
      "BOTTLE": "زجاجة",
      "CAN": "علبة",
      "BOX": "صندوق",
      "BAG": "كيس",
      "BUNCH": "حزمة"
    },
    "long": {
      "PIECE": "قطع",
      "KG": "كيلوغرام (كغ)",
      "G": "غرام (غ)",
      "LB": "رطل",
      "OZ": "أونصة",
      "L": "لتر",
      "ML": "مليلتر (مل)",
      "PACK": "عبوات",
      "DOZEN": "دزينة",
      "BOTTLE": "زجاجات",
      "CAN": "علب",
      "BOX": "صناديق",
      "BAG": "أكياس",
      "BUNCH": "حزم"
    }
  },
  "mobile": {
    "tabs": {
      "home": "الرئيسية"
    },
    "auth": {
      "showPassword": "إظهار كلمة المرور",
      "hidePassword": "إخفاء كلمة المرور",
      "welcome": "مرحبًا بك في ليستا! أرسلنا رابط التحقق إلى {{email}}."
    },
    "home": {
      "greeting": "مرحبًا،",
      "continue": "تابع التسوق",
      "addTo": "أضف إلى {{name}}",
      "activeLists": "القوائم النشطة",
      "itemsLeft": "عناصر للشراء",
      "recent": "القوائم الأخيرة",
      "seeAll": "عرض الكل"
    },
    "lists": {
      "longPressHint": "اضغط مطولًا لمزيد من الإجراءات"
    },
    "list": {
      "emptyBody": "اضغط «إضافة عنصر» ثم اكتب أو اختر من المفضلة. اضغط على العنصر لتعليمه كمُشترى، واسحبه لتعليمه أو حذفه، واضغط مطولًا لتعديله."
    },
    "items": {
      "rowHint": "اضغط مرتين لتعليمه كمُشترى. اسحب أو اضغط مطولًا لمزيد من الخيارات.",
      "unbuy": "لم يُشترَ"
    },
    "add": {
      "title": "أضف إلى {{name}}",
      "done": "تم",
      "favorites": "مفضلتك",
      "results": "النتائج",
      "emptyPrompt": "اكتب اسم عنصر واضغط إدخال لإضافته. تظهر هنا العناصر التي تستخدمها وتضع عليها نجمة.",
      "longPressHint": "اضغط مطولًا لتحديد الكمية والوحدة وإضافة ملاحظة",
      "addedQty": "أُضيف · {{quantity}} في القائمة",
      "addedCount_zero": "لم تُضف أي عناصر",
      "addedCount_one": "أُضيف عنصر واحد",
      "addedCount_two": "أُضيف عنصران",
      "addedCount_few": "أُضيفت {{count}} عناصر",
      "addedCount_many": "أُضيف {{count}} عنصرًا",
      "addedCount_other": "أُضيف {{count}} عنصر",
      "quickPicks": "المستخدمة مؤخرًا والمفضلة"
    },
    "settings": {
      "languageHint": "التبديل بين العربية والإنجليزية يعيد تشغيل التطبيق لتغيير اتجاه الواجهة.",
      "offlineHint": "تبقى القوائم التي فتحتها ظاهرة إذا انقطع الاتصال. التعديل الكامل دون اتصال مخطط له.",
      "version": "الإصدار {{version}}"
    },
    "reorder": {
      "moveUp": "تحريك لأعلى",
      "moveDown": "تحريك لأسفل",
      "hint": "اضغط مطولًا على المقبض ثم اسحب للترتيب.",
      "sortTitle": "الترتيب"
    },
    "sponsored": {
      "setCountry": "حدّد دولتك في الملف الشخصي على موقع ليستا لترى القوائم المميّزة القريبة منك."
    }
  },
  "notifications": {
    "title": "الإشعارات",
    "openLabel": "الإشعارات",
    "unreadBadge_zero": "لا إشعارات غير مقروءة",
    "unreadBadge_one": "إشعار واحد غير مقروء",
    "unreadBadge_two": "إشعاران غير مقروءين",
    "unreadBadge_few": "{{count}} إشعارات غير مقروءة",
    "unreadBadge_many": "{{count}} إشعارًا غير مقروء",
    "unreadBadge_other": "{{count}} إشعار غير مقروء",
    "markAllRead": "تعليم الكل كمقروء",
    "markRead": "تعليم كمقروء",
    "unread": "غير مقروء",
    "empty": {
      "title": "لا توجد إشعارات",
      "body": "تظهر هنا طلبات المشاركة وتغييرات الصلاحيات."
    },
    "shareRequested": "شاركك {{actor}} قائمة «{{list}}» ({{role}}). اقبلها لتبدأ استخدامها.",
    "roleChanged": "غيّر {{actor}} صلاحيتك على «{{list}}» إلى «{{role}}».",
    "review": "مراجعة",
    "openList": "فتح القائمة",
    "someone": "شخص ما",
    "shareAccepted": "قبل {{actor}} قائمة «{{list}}» ({{role}}).",
    "shareDeclined": "رفض {{actor}} قائمة «{{list}}».",
    "listDeleted": "لم تعد قائمة «{{list}}» متاحة: حذف مالكها حسابه."
  },
  "meals": {
    "title": "الوصفات حسب المطبخ",
    "cuisineTitle": "وصفات المطبخ {{name}}",
    "mealCount_zero": "لا وصفات",
    "mealCount_one": "وصفة واحدة",
    "mealCount_two": "وصفتان",
    "mealCount_few": "{{count}} وصفات",
    "mealCount_many": "{{count}} وصفة",
    "mealCount_other": "{{count}} وصفة",
    "ingredientCount_zero": "لا مكونات",
    "ingredientCount_one": "مكوّن واحد",
    "ingredientCount_two": "مكوّنان",
    "ingredientCount_few": "{{count}} مكونات",
    "ingredientCount_many": "{{count}} مكوّنًا",
    "ingredientCount_other": "{{count}} مكوّن",
    "servings": "تكفي {{count}} أشخاص",
    "ingredients": "المكونات",
    "ingredientsHint": "ألغِ تحديد ما لديك بالفعل، ثم أضف الباقي إلى قائمة أو أكثر.",
    "selectAll": "تحديد الكل",
    "clearAll": "إلغاء تحديد الكل",
    "selectedCount_zero": "لا شيء محدد",
    "selectedCount_one": "محدد: واحد",
    "selectedCount_two": "محدد: اثنان",
    "selectedCount_few": "محدد: {{count}}",
    "selectedCount_many": "محدد: {{count}}",
    "selectedCount_other": "محدد: {{count}}",
    "toggleIngredient": "{{name}}، {{quantity}}",
    "addSelected": "إضافة المحدد إلى قائمة",
    "addAll": "إضافة الكل إلى قائمة",
    "addToListTitle": "إضافة المكونات إلى قائمة",
    "chooseList": "اختر قائمة",
    "noLists": "ليست لديك قائمة يمكنك تعديلها بعد. أنشئ قائمة أولًا.",
    "confirmAdd_zero": "لا شيء للإضافة",
    "confirmAdd_one": "إضافة مكوّن واحد",
    "confirmAdd_two": "إضافة مكوّنين",
    "confirmAdd_few": "إضافة {{count}} مكونات",
    "confirmAdd_many": "إضافة {{count}} مكوّنًا",
    "confirmAdd_other": "إضافة {{count}} مكوّن",
    "added_zero": "لم تُضف مكونات إلى {{list}}",
    "added_one": "أُضيف مكوّن واحد إلى {{list}}",
    "added_two": "أُضيف مكوّنان إلى {{list}}",
    "added_few": "أُضيفت {{count}} مكونات إلى {{list}}",
    "added_many": "أُضيف {{count}} مكوّنًا إلى {{list}}",
    "added_other": "أُضيف {{count}} مكوّن إلى {{list}}",
    "openList": "فتح القائمة",
    "nothingSelected": "حدّد مكوّنًا واحدًا على الأقل",
    "tally": "من {{total}} محدد",
    "chooseLists": "أضف إلى هذه القوائم",
    "newList": "قائمة جديدة",
    "newListName": "اسم القائمة الجديدة",
    "cancelNewList": "عدم إنشاء قائمة جديدة",
    "noTarget": "اختر قائمة أو أنشئ قائمة جديدة",
    "noListsYet": "لا توجد قوائم بعد - أنشئ قائمة جديدة لهذه الوصفة.",
    "listCount_zero": "لا قوائم",
    "listCount_one": "قائمة واحدة",
    "listCount_two": "قائمتين",
    "listCount_few": "{{count}} قوائم",
    "listCount_many": "{{count}} قائمة",
    "listCount_other": "{{count}} قائمة",
    "addToLists_zero": "لا مكونات للإضافة",
    "addToLists_one": "إضافة مكوّن واحد إلى {{lists}}",
    "addToLists_two": "إضافة مكوّنين إلى {{lists}}",
    "addToLists_few": "إضافة {{count}} مكونات إلى {{lists}}",
    "addToLists_many": "إضافة {{count}} مكوّنًا إلى {{lists}}",
    "addToLists_other": "إضافة {{count}} مكوّن إلى {{lists}}",
    "empty": "لا توجد وصفات هنا بعد",
    "mealsEmpty": "لا توجد مطابخ بعد"
  },
  "archivedPage": {
    "title": "القوائم المؤرشفة",
    "empty": {
      "title": "لا توجد قوائم مؤرشفة",
      "body": "القوائم التي تؤرشفها ستظهر هنا."
    }
  },
  "ai": {
    "suggest": "اقتراح عناصر بالذكاء الاصطناعي",
    "title": "اقتراح عناصر",
    "optional": "اختياري: دع الذكاء الاصطناعي يقترح العناصر",
    "description": "ما الغرض من هذه القائمة؟",
    "descriptionPlaceholder": "مثال: عشاء إفطار لستة أشخاص بدون مأكولات بحرية",
    "frequency": "عدد المرات",
    "frequencies": {
      "ONE_TIME": "مرة واحدة",
      "DAILY": "يومياً",
      "WEEKLY": "أسبوعياً"
    },
    "locationHint": "تعتمد الاقتراحات على بلدك ({{country}}).",
    "setLocation": "حدّد بلدك في الملف الشخصي للحصول على اقتراحات أفضل.",
    "go": "اقترح",
    "again": "حاول مرة أخرى",
    "working": "جارٍ التفكير في العناصر…",
    "source": {
      "ai": "كتبها الذكاء الاصطناعي - راجعها قبل التسوق.",
      "rules": "اقتراحات مدمجة (الذكاء الاصطناعي غير مفعّل)."
    },
    "select": "اختر العناصر المراد إضافتها ({{selected}}/{{total}})",
    "toggle": "إضافة {{name}}",
    "quantity": "كمية {{name}}",
    "add": "إضافة {{count}} عناصر",
    "added": "تمت إضافة {{count}} عناصر إلى {{name}}",
    "later": "تخطّي",
    "errors": {
      "empty": "لا توجد اقتراحات لهذا الوصف. جرّب وصف القائمة بشكل مختلف.",
      "generic": "تعذّر الحصول على اقتراحات الآن."
    },
    "scan": {
      "button": "مسح قائمة ورقية",
      "title": "العناصر من صورتك",
      "reading": "جارٍ قراءة قائمتك…",
      "review": "راجع ما قرأناه. ألغِ تحديد أي عنصر غير صحيح، ثم أضف الباقي.",
      "newItem": "عنصر جديد: سيُضاف إلى عناصرك",
      "add_one": "إضافة عنصر واحد",
      "add_other": "إضافة {{count}} عناصر",
      "added_one": "أُضيف عنصر واحد من صورتك",
      "added_other": "أُضيفت {{count}} عناصر من صورتك",
      "none": "لم نجد عناصر في هذه الصورة",
      "noneBody": "حاول مجددًا بحيث تظهر القائمة كاملة ومستوية وفي إضاءة جيدة.",
      "upload": "رفع صورة قائمة",
      "chooseAnother": "اختيار صورة أخرى",
      "retake": "التقاط صورة أخرى",
      "notImage": "هذا الملف ليس صورة يمكننا قراءتها. اختر صورة JPEG أو PNG أو WebP.",
      "privacy": "تُرسل صورتك إلى مزوّد الذكاء الاصطناعي لدينا لقراءة القائمة فقط، ولا تُخزَّن."
    }
  },
  "sponsored": {
    "title": "قوائم مميّزة",
    "label": "إعلان",
    "by": "من {{name}}",
    "open": "فتح {{title}}",
    "itemCount_zero": "لا عناصر",
    "itemCount_one": "عنصر واحد",
    "itemCount_two": "عنصران",
    "itemCount_few": "{{count}} عناصر",
    "itemCount_many": "{{count}} عنصراً",
    "itemCount_other": "{{count}} عنصر",
    "selectItems": "العناصر ({{selected}}/{{total}})",
    "chooseLists": "إلى أي القوائم تريد الإضافة؟",
    "noLists": "أنشئ قائمة أولاً ثم أضف هذه العناصر إليها.",
    "addButton_zero": "إضافة",
    "addButton_one": "إضافة عنصر إلى {{lists}} قائمة",
    "addButton_two": "إضافة عنصرين إلى {{lists}} قائمة",
    "addButton_few": "إضافة {{count}} عناصر إلى {{lists}} قائمة",
    "addButton_many": "إضافة {{count}} عنصراً إلى {{lists}} قائمة",
    "addButton_other": "إضافة {{count}} عنصر إلى {{lists}} قائمة",
    "added": "تمت إضافة {{count}} عناصر إلى {{lists}}",
    "toggle": "إضافة {{name}}",
    "items": "العناصر",
    "nothingSelected": "حدّد عنصرًا واحدًا على الأقل",
    "noListsYet": "لا توجد قوائم بعد - أنشئ قائمة جديدة لهذه العناصر.",
    "addToLists_zero": "لا عناصر للإضافة",
    "addToLists_one": "إضافة عنصر واحد إلى {{lists}}",
    "addToLists_two": "إضافة عنصرين إلى {{lists}}",
    "addToLists_few": "إضافة {{count}} عناصر إلى {{lists}}",
    "addToLists_many": "إضافة {{count}} عنصرًا إلى {{lists}}",
    "addToLists_other": "إضافة {{count}} عنصر إلى {{lists}}",
    "admin": {
      "title": "القوائم المميّزة",
      "intro": "قوائم تظهر في الصفحة الرئيسية للمستخدمين في الدول والمدن التي تختارها. لا يمكن للمستخدمين تعديلها.",
      "new": "قائمة مميّزة جديدة",
      "add": "قائمة جديدة",
      "edit": "تعديل القائمة المميّزة",
      "create": "إنشاء",
      "empty": {
        "title": "لا توجد قوائم مميّزة بعد",
        "body": "أنشئ قائمة، واختر أماكن ظهورها، ثم انشرها."
      },
      "forbidden": "ليس لديك صلاحية الوصول إلى هذه الصفحة.",
      "fields": {
        "title": "العنوان",
        "sponsor": "الراعي أو العلامة التجارية",
        "description": "الوصف",
        "status": "الحالة",
        "startsAt": "تبدأ",
        "endsAt": "تنتهي",
        "color": "اللون"
      },
      "status": {
        "DRAFT": "مسودة",
        "PUBLISHED": "منشورة",
        "ARCHIVED": "مؤرشفة"
      },
      "targets": {
        "title": "أماكن الظهور",
        "hint": "أضف دولة لإظهارها لكل من فيها، أو دولة ومدينة لإظهارها في تلك المدينة فقط.",
        "country": "الدولة",
        "city": "المدينة (اختياري)",
        "add": "إضافة مكان",
        "remove": "إزالة {{place}}",
        "wholeCountry": "الدولة كاملة",
        "none": "أضف مكاناً واحداً على الأقل للنشر."
      },
      "items": {
        "title": "العناصر",
        "searchPlaceholder": "ابحث في الكتالوج…",
        "customPlaceholder": "أو اكتب منتجاً لعلامة تجارية، مثال: تمور أكمي 500غ",
        "addCustom": "إضافة منتج",
        "remove": "إزالة {{name}}",
        "none": "أضف عنصراً واحداً على الأقل.",
        "quantity": "كمية {{name}}"
      },
      "save": "حفظ",
      "saved": "تم حفظ القائمة المميّزة",
      "deleted": "تم حذف القائمة المميّزة",
      "deleteTitle": "حذف هذه القائمة المميّزة؟",
      "deleteBody": "ستختفي لدى جميع المستخدمين ولا يمكن التراجع.",
      "schedule": "{{from}} – {{to}}",
      "always": "تعمل دائماً",
      "places_zero": "لا أماكن",
      "places_one": "مكان واحد",
      "places_two": "مكانان",
      "places_few": "{{count}} أماكن",
      "places_many": "{{count}} مكاناً",
      "places_other": "{{count}} مكان",
      "errors": {
        "title": "أدخل العنوان",
        "sponsor": "أدخل اسم الراعي",
        "items": "أضف عنصراً واحداً على الأقل",
        "targets": "أضف مكاناً واحداً على الأقل للنشر",
        "dates": "يجب أن يكون الانتهاء بعد البدء"
      },
      "hidden": {
        "draft": "غير ظاهرة للمستخدمين: إنها مسودة. عدّلها واجعل الحالة «منشورة».",
        "archived": "غير ظاهرة للمستخدمين: إنها مؤرشفة.",
        "noPlaces": "غير ظاهرة للمستخدمين: أضف دولة واحدة على الأقل.",
        "notStarted": "غير ظاهرة للمستخدمين بعد: تبدأ لاحقاً.",
        "ended": "غير ظاهرة للمستخدمين: انتهى تاريخها."
      },
      "forYou": {
        "yes": "منشورة وتظهر لك أيضاً (ملفك: {{place}}).",
        "noCountry": "منشورة لكنها لا تظهر لك: لم تحدد دولة في ملفك. حدّدها في الملف الشخصي.",
        "otherCountry": "منشورة لكنها لا تظهر لك: ملفك في {{place}}، وهو ليس من أماكن ظهورها.",
        "otherCity": "منشورة لكنها لا تظهر لك: مدينة ملفك ({{place}}) مكتوبة بشكل مختلف عن مدنها. أضف الدولة كاملة أو مدينتك كما هي مكتوبة في ملفك."
      }
    },
    "setCountry": {
      "body": "حدّد دولتك لترى العروض القريبة منك.",
      "action": "تحديد الدولة"
    }
  },
  "publicList": {
    "viewOnly": "عرض فقط",
    "live": "مباشر",
    "liveHint": "يتحدّث تلقائيًا",
    "sharedBy": "شاركها {{name}}",
    "allBought": "تم شراء كل شيء",
    "bought": "تم شراؤها ({{count}})",
    "empty": "هذه القائمة فارغة.",
    "archived": "هذه القائمة مؤرشفة.",
    "invalidTitle": "هذا الرابط غير متاح",
    "invalidBody": "ربما انتهت صلاحيته أو أوقفه المالك. اطلب منه رابطًا جديدًا.",
    "ctaTitle": "أنشئ قوائم تسوقك الخاصة مع ليستا",
    "ctaBody": "أنشئ القوائم، وأضف العناصر من الفهرس، وشاركها مع العائلة والأصدقاء - مجانًا.",
    "register": "أنشئ حسابًا مجانيًا",
    "login": "لدي حساب بالفعل",
    "home": "الصفحة الرئيسية لليستا",
    "offline": "انقطع الاتصال - نعرض آخر تحديث.",
    "remainingLabel_zero": "عنصر متبقٍ",
    "remainingLabel_one": "عنصر متبقٍ",
    "remainingLabel_two": "عنصران متبقيان",
    "remainingLabel_few": "عناصر متبقية",
    "remainingLabel_many": "عنصرًا متبقيًا",
    "remainingLabel_other": "عنصر متبقٍ",
    "updated": "آخر تحديث {{date}}",
    "validUntil": "الرابط صالح حتى {{date}}",
    "order": {
      "category": "حسب الفئة",
      "list": "ترتيب القائمة",
      "name": "الاسم (أ–ي)"
    }
  },
  "landing": {
    "meta": {
      "title": "ليستا - املأ قائمة مشترياتك في ثوانٍ وشاركها مباشرة",
      "description": "ليستا تطبيق مجاني لقوائم التسوق على الويب والجوال. أضف العناصر بالبحث أو الأقسام أو الوصفات أو اقتراحات الذكاء الاصطناعي أو بنفسك، وشارك قوائم حيّة مع العائلة والأصدقاء."
    },
    "nav": {
      "addItems": "إضافة العناصر",
      "sharing": "المشاركة",
      "features": "المميزات",
      "login": "تسجيل الدخول",
      "register": "التسجيل",
      "home": "الصفحة الرئيسية لليستا",
      "menu": "الرئيسية"
    },
    "hero": {
      "eyebrow": "قوائم التسوق بكل سهولة",
      "title": "املأ قائمتك في ثوانٍ، وتسوّقوا معًا.",
      "body": "ابحث، أو تصفّح الأقسام، أو اختر وصفة، أو دع الذكاء الاصطناعي يقترح العناصر، أو اكتبها بنفسك. ثم شارك القائمة مع من تتسوّق معهم ليعمل الجميع على القائمة نفسها محدّثة دائمًا.",
      "cta": "أنشئ حسابك المجاني",
      "login": "لدي حساب بالفعل",
      "note": "مجاني · بالعربية والإنجليزية · على الويب والجوال",
      "imageAlt": "ليستا على الحاسوب تعرض قوائم تسوق ملوّنة",
      "phoneAlt": "قائمة تسوق مشتركة على الجوال"
    },
    "add": {
      "title": "خمس طرق سهلة لإضافة العناصر",
      "intro": "استخدم الأسرع لك في كل مرة، فكل شيء يصل إلى القائمة نفسها.",
      "tabsLabel": "طرق إضافة العناصر",
      "w": {
        "search": {
          "tab": "البحث",
          "title": "اكتب بضعة أحرف",
          "body": "تظهر النتائج أثناء الكتابة بالعربية أو الإنجليزية، والبحث يفهم الجمع واختلاف الإملاء. المس + لإضافة العنصر بوحدته المعتادة.",
          "b": [
            "مئات العناصر اليومية جاهزة للإضافة",
            "اعرف ما هو موجود في قائمتك بالفعل",
            "العناصر الأخيرة والمفضلة على بعد لمسة"
          ],
          "alt": "نتائج البحث عن جبن مع زر إضافة لكل نتيجة"
        },
        "categories": {
          "tab": "الأقسام",
          "title": "تصفّح حسب القسم",
          "body": "لا تعرف ماذا تحتاج؟ افتح قسمًا - فواكه وخضروات، ألبان، لحوم، مخبوزات، مؤن، تنظيف، أطفال والمزيد - والمس ما تريد.",
          "b": [
            "أقسام واضحة مع أيقونات",
            "أضف عدة عناصر دون مغادرة اللوحة",
            "عناصرك الخاصة لها قسمها أيضًا"
          ],
          "alt": "لوحة إضافة العناصر تعرض الأقسام بأيقوناتها"
        },
        "meals": {
          "tab": "الوصفات",
          "title": "اختر وصفة واحصل على مكوّناتها",
          "body": "اختر طبقًا من المطبخ العربي أو الإيطالي أو الهندي أو المكسيكي، وألغِ تحديد ما لديك في البيت، وأضف الباقي إلى قائمة بلمسة واحدة.",
          "b": [
            "المكوّنات والكميات لكل وصفة",
            "كل طبق يظهر في بطاقة بصورة",
            "العناصر الموجودة في القائمة تُدمج ولا تتكرر"
          ],
          "alt": "وصفة بمكوّناتها وزر إضافة الكل إلى قائمة"
        },
        "ai": {
          "tab": "اقتراحات الذكاء الاصطناعي",
          "title": "صِف ما تريد ودع الذكاء الاصطناعي يملؤها",
          "body": "أخبر ليستا لماذا القائمة - «إفطار لستة أشخاص بدون مأكولات بحرية» - فتقترح العناصر والكميات. ألغِ تحديد ما لا تريده وأضف الباقي.",
          "b": [
            "يراعي بلدك",
            "لا يُضاف شيء قبل موافقتك",
            "اقتراحات مدمجة عند عدم توفر الذكاء الاصطناعي"
          ],
          "alt": "عناصر مقترحة مع مربعات اختيار وكميات"
        },
        "manual": {
          "tab": "عناصرك الخاصة",
          "title": "أضف أي شيء بطريقتك",
          "body": "لم تجده في الفهرس؟ اكتب الاسم وأضفه كعنصر خاص بك مع الكمية والوحدة وملاحظة. وتتذكره ليستا للمرة القادمة.",
          "b": [
            "كمية ووحدة وملاحظات لكل عنصر",
            "يُحفظ في عناصري لتجده مجددًا",
            "عدّل أي عنصر لاحقًا"
          ],
          "alt": "إضافة عنصر جديد مع الكمية والوحدة وملاحظة"
        }
      }
    },
    "share": {
      "eyebrow": "مشاركة مباشرة",
      "title": "تسوّقوا معًا على القائمة نفسها",
      "intro": "شارك القائمة مع العائلة أو شركاء السكن أو الأصدقاء. من في المتجر يرى ما تبقّى، ومن في البيت يواصل الإضافة.",
      "together": {
        "title": "الجميع يعمل على قائمة واحدة",
        "body": "عندما يضيف عمر التمر أو يشطب الخبز، تراه سارة في قائمتها أيضًا. ويوضح رأس القائمة مع من تمت مشاركتها وهل يمكنك التعديل.",
        "b": [
          "ادعُ الأشخاص بالبريد كمحرّرين أو مشاهدين",
          "التغييرات تتزامن بين الجوالات والحواسيب",
          "المالك وحده يغيّر اسم القائمة أو لونها أو يحذفها"
        ]
      },
      "ownerTag": "سارة · المالكة",
      "partnerTag": "عمر · يمكنه التعديل",
      "ownerAlt": "جوال سارة يعرض قائمة مشتريات الأسبوع المشتركة",
      "partnerAlt": "جوال عمر يعرض القائمة نفسها ويمكنه تعديلها",
      "invite": {
        "title": "ادعُ الأشخاص أو أرسل رابطًا",
        "body": "أضف الأشخاص بالبريد، أو أنشئ رابطًا للقراءة فقط وأرسله عبر واتساب أو تيليغرام أو البريد. كل من يفتحه يرى القائمة الحيّة دون حساب.",
        "b": [
          "صفحة الرابط تتحدّث كل بضع ثوانٍ",
          "الروابط تنتهي، ويمكنك إيقاف أي رابط في أي وقت",
          "تفضّل الورق؟ نزّل القائمة أو شاركها بصيغة PDF"
        ],
        "alt": "نافذة المشاركة مع رابط نشط وشخصين",
        "linkAlt": "قائمة مشتركة مفتوحة من رابط على الجوال وعليها وسم مباشر"
      }
    },
    "featuresTitle": "مصمَّمة لطريقة تسوّقك",
    "featuresIntro": "كل ما يجعل تسوّق الأسبوع أسهل.",
    "f": {
      "listview": {
        "title": "قائمة تعمل معك أثناء التسوق",
        "body": "اشطب العناصر وهي تدخل العربة. تنتقل المشتراة جانبًا ويوضح رأس القائمة عدد المتبقي.",
        "b": [
          "مجمّعة حسب القسم أو بترتيبك الخاص",
          "ابحث وصفِّ حسب القسم وبدّل بين الصفوف والبلاطات",
          "الكميات والوحدات والملاحظات بلمحة"
        ],
        "alt": "قائمة تسوق مجمّعة حسب القسم مع الكميات"
      },
      "favorites": {
        "title": "المفضلة لما تشتريه دائمًا",
        "body": "ضع نجمة على العنصر مرة واحدة ويبقى على بعد لمسة في كل القوائم.",
        "b": [
          "صفحة مفضلة خاصة بك مرتبة حسب القسم",
          "أضف إلى المفضلة من أي قائمة أو نتيجة بحث",
          "أضفها مباشرة إلى القائمة التي تختارها"
        ],
        "alt": "صفحة المفضلة مجمّعة حسب القسم"
      }
    },
    "extrasTitle": "والمزيد أيضًا",
    "extras": {
      "colours": {
        "title": "قوائم ملوّنة",
        "body": "امنح كل قائمة لونها، وثبّت المهمة منها، وأرشف القديمة، ورتّبها بالسحب كما تريد."
      },
      "sponsored": {
        "title": "عروض من المتاجر المحلية",
        "body": "قوائم جاهزة من متاجر مدينتك مثل سلة رمضان. أضف ما تريده منها بلمسة واحدة."
      },
      "pdf": {
        "title": "تصدير PDF",
        "body": "نزّل ملف PDF مرتبًا لأي قائمة، أو شاركه مباشرة من جوالك."
      }
    },
    "moreTitle": "مصمَّمة للجميع",
    "more": {
      "language": {
        "title": "الإنجليزية والعربية",
        "body": "التطبيق كاملًا باللغتين، مع تخطيط سليم من اليمين إلى اليسار.",
        "alt": "ليستا بالإنجليزية"
      },
      "dark": {
        "title": "مظهر فاتح وداكن",
        "body": "مريح في المتجر وبعد حلول الظلام.",
        "alt": "ليستا بالمظهر الداكن"
      },
      "phone": {
        "title": "مصمَّمة لجوالك",
        "body": "ثبّتها على الشاشة الرئيسية واحتفظ بقوائمك حتى لو انقطعت الشبكة.",
        "alt": "نظرة عامة على القوائم في ليستا على الجوال"
      }
    },
    "final": {
      "title": "جاهز لتسوّق أسبوعي أسهل؟",
      "body": "أنشئ حسابك المجاني في دقيقة وابدأ بملء أول قائمة.",
      "cta": "أنشئ حسابك المجاني",
      "login": "تسجيل الدخول"
    },
    "footer": {
      "rights": "© {{year}} ليستا. جميع الحقوق محفوظة."
    }
  },
  "legal": {
    "updated": "آخر تحديث: {{date}}",
    "contactEmail": "support@onelista.com",
    "nav": {
      "privacy": "سياسة الخصوصية",
      "terms": "الشروط والأحكام",
      "cookies": "إعدادات ملفات تعريف الارتباط",
      "back": "العودة إلى ليستا",
      "label": "قانوني"
    },
    "privacy": {
      "title": "سياسة الخصوصية",
      "intro": "توضح هذه السياسة البيانات الشخصية التي تجمعها ليستا وأسباب جمعها ومدة الاحتفاظ بها وحقوقك. وقد أُعدّت وفق نظام حماية البيانات الشخصية في المملكة العربية السعودية، ووفق اللائحة العامة لحماية البيانات (GDPR) للمستخدمين في الاتحاد الأوروبي والمنطقة الاقتصادية الأوروبية.",
      "sections": [
        {
          "title": "١. من نحن",
          "body": [
            "ليستا (\"نحن\") هي جهة التحكم في البيانات الشخصية الموضحة في هذه السياسة.",
            "لأي سؤال أو طلب يتعلق بالخصوصية، راسلنا على support@onelista.com."
          ]
        },
        {
          "title": "٢. البيانات التي نجمعها",
          "body": [
            "• بيانات الحساب: بريدك الإلكتروني واسم العرض وكلمة المرور. لا نخزّن كلمة المرور نفسها أبدًا، بل تجزئة أحادية الاتجاه لها باستخدام Argon2id.",
            "• محتواك: القوائم والعناصر والكميات والملاحظات والعناصر المخصصة والمفضلة والعناصر المستخدمة مؤخرًا وخطط الوجبات.",
            "• بيانات المشاركة: الأشخاص الذين تشاركهم قائمة ودورهم، والبريد الإلكتروني لكل من تدعوه.",
            "• التفضيلات: اللغة والمظهر ونظام الوحدات، وبلدك ومدينتك إن اخترت إضافتهما.",
            "• البيانات التقنية: عنوان IP ونوع المتصفح أو التطبيق ومعرّفات الطلبات، وتُستخدم للأمان وتشغيل الخدمة.",
            "• الرسائل التي نرسلها إليك: رسائل الحساب (التحقق وإعادة تعيين كلمة المرور والدعوات) والإشعارات داخل التطبيق.",
            "لا نجمع بيانات الدفع أو الموقع الدقيق أو جهات الاتصال أو أي بيانات حساسة، ولا نشتري بيانات عنك من الآخرين."
          ]
        },
        {
          "title": "٣. لماذا نستخدمها وما الأساس النظامي",
          "body": [
            "• لتقديم الخدمة التي اشتركت فيها: حسابك وقوائمك والمشاركة والتصدير. الأساس النظامي: تنفيذ العقد بيننا (المادة ٦ من نظام حماية البيانات الشخصية؛ المادة ٦(١)(ب) من GDPR).",
            "• للحفاظ على أمان الخدمة: حماية تسجيل الدخول وحدود الطلبات وسجل تدقيق للأحداث الأمنية. الأساس النظامي: مصلحتنا المشروعة في حمايتك وحماية الخدمة (المادة ٦(١)(و) من GDPR) والتزاماتنا النظامية.",
            "• لعرض القوائم المموّلة وتكييف اقتراحات القوائم وفق بلدك ومدينتك، فقط إن أضفتهما. الأساس النظامي: موافقتك، ويمكنك سحبها بحذفهما من ملفك الشخصي.",
            "• لتعبئة بلدك عند التسجيل، فقط إن سمحت لمتصفحك بمشاركة موقعك: يُرسل موقعك، مقرّبًا إلى نحو 10 كم، إلى BigDataCloud التي تخبرنا بالبلد فقط. لا نخزّن موقعك، ويمكنك تغيير البلد قبل التسجيل. الأساس النظامي: موافقتك التي تمنحها في طلب الموقع في متصفحك.",
            "• لتحسين الكتالوج المشترك: عندما تضيف عنصرًا خاصًا بك (مثل «خلطة زعتر»)، يرى المسؤولون لدينا هذا الاسم وعدد من أضافوه، دون معرفة من هم. وقد ينضم الاسم إلى الكتالوج، فيصبح عنصرك الخاص هو عنصر الكتالوج في قوائمك. الأساس النظامي: مصلحتنا المشروعة في كتالوج أفضل للجميع.",
            "• لتذكّر التفضيلات الاختيارية على جهازك (مثل طريقة عرض القوائم). الأساس النظامي: موافقتك عبر إعدادات ملفات تعريف الارتباط.",
            "• لإرسال رسائل الحساب التي تحتاجها، مثل إعادة تعيين كلمة المرور. لا نرسل رسائل تسويقية.",
            "لا نبيع بياناتك الشخصية، ولا نعرض إعلانات لأطراف أخرى، ولا ننشئ ملفات تعريف إعلانية، ولا نتخذ قرارات بشأنك ذات آثار نظامية أو مماثلة تعتمد على المعالجة الآلية وحدها."
          ]
        },
        {
          "title": "٤. اقتراحات القوائم بالذكاء الاصطناعي وصور القوائم الورقية",
          "body": [
            "عندما تطلب من ليستا اقتراح قائمة، نرسل إلى مزوّد الذكاء الاصطناعي لدينا، Anthropic، ما يحتاجه لاقتراح العناصر: الوصف الذي تكتبه، ومدى تكرار حاجتك للقائمة، واللغة، وأسماء العناصر الموجودة في القائمة، ومدينتك وبلدك إن أضفتهما إلى ملفك الشخصي. ولا نرسل أبدًا اسمك أو بريدك الإلكتروني أو قوائمك الأخرى.",
            "عند مسح قائمة ورقية، تُرسل الصورة (مصغّرة على جهازك ودون بيانات الموقع) إلى Anthropic لقراءة العناصر المكتوبة فيها فقط. لا نخزّن الصورة ولا ما قُرئ منها ولا نسجّلهما، ولا يُضاف شيء إلى قائمتك حتى توافق عليه. تجنّب تصوير أي شيء آخر، مثل الأشخاص أو المستندات.",
            "لا نسجّل الوصف ولا نخزّنه، وتعالج Anthropic هذه البيانات نيابةً عنا بموجب اتفاقية معالجة بيانات. لا تُضمّن أي معلومات شخصية أو حساسة في الوصف، ويمكنك إنشاء القوائم دون استخدام الاقتراحات."
          ]
        },
        {
          "title": "٥. مع من نشارك البيانات",
          "body": [
            "• يرى الأشخاص الذين تشاركهم قائمة محتواها واسم العرض الخاص بك ودورك. ولا يرى عناوين البريد الإلكتروني للأعضاء إلا مالك القائمة.",
            "• يمكن لأي شخص لديه رابط مشاركة أنشأته قراءة تلك القائمة حتى تلغي الرابط. ولا تعرض روابط المشاركة أي بريد إلكتروني.",
            "• مقدّمو الخدمات الذين يعالجون البيانات لصالحنا بموجب عقود: مزوّد الاستضافة، ومزوّد البريد الإلكتروني (Hostinger)، ومزوّد الذكاء الاصطناعي (Anthropic)، وBigDataCloud فقط عند مشاركة موقعك أثناء التسجيل. ولا يجوز لهم استخدام البيانات إلا لتقديم خدمتهم لنا.",
            "• الجهات المختصة، عندما يقتضي النظام ذلك أو لحماية حقوق مستخدمينا وسلامتهم."
          ]
        },
        {
          "title": "٦. نقل البيانات خارج الحدود",
          "body": [
            "يعالج بعض مزوّدينا البيانات خارج المملكة العربية السعودية أو خارج الاتحاد الأوروبي والمنطقة الاقتصادية الأوروبية، مثل الولايات المتحدة. وفي هذه الحالة ننقل الحد الأدنى اللازم فقط، ونعتمد الضمانات التي يشترطها النظام: شروط النقل وفق نظام حماية البيانات الشخصية ولائحته التنفيذية، وبالنسبة لبيانات الاتحاد الأوروبي، البنود التعاقدية القياسية المعتمدة من المفوضية الأوروبية أو قرار الكفاية."
          ]
        },
        {
          "title": "٧. ملفات تعريف الارتباط والتخزين على جهازك",
          "body": [
            "لا تستخدم ليستا أي ملفات تعريف ارتباط إعلانية أو تحليلية أو للتتبع من أطراف أخرى.",
            "• الضرورية: ملف تعريف ارتباط واحد، lista_rt، يبقيك مسجّلًا. وهو من نوع HttpOnly، ولا يُرسل إلا إلى نقاط تسجيل الدخول لدينا، ويدوم حتى ٣٠ يومًا. كما نحتفظ بنسخة من الصفحات التي فتحتها ليعمل التطبيق دون اتصال. ولا يمكن إيقافها لأن التطبيق لا يعمل بدونها.",
            "• التفضيلات (اختيارية): لغتك ومظهرك وطريقة عرض القوائم وترتيبها والقوائم التي أضفت إليها مؤخرًا، وتُخزّن في التخزين المحلي لمتصفحك. بموافقتك نحتفظ بها بين الزيارات، وبدونها تعود إلى الوضع الافتراضي عند إغلاق التطبيق.",
            "يمكنك تغيير اختيارك في أي وقت من \"إعدادات ملفات تعريف الارتباط\" أسفل الصفحة أو من الإعدادات."
          ]
        },
        {
          "title": "٨. مدة الاحتفاظ بالبيانات",
          "body": [
            "• حسابك ومحتواك: حتى تحذفها أو تحذف حسابك.",
            "• القوائم المحذوفة: ٣٠ يومًا في \"المحذوفة مؤخرًا\"، ثم تُحذف نهائيًا.",
            "• بعد حذف حسابك: تُحذف البيانات الشخصية فورًا من النظام، ومن النسخ الاحتياطية خلال ٣٥ يومًا.",
            "• ملفات PDF والبيانات المُصدّرة: ٢٤ ساعة.",
            "• جلسات تسجيل الدخول: تُحذف الجلسات المنتهية أو الملغاة بعد ٧ أيام.",
            "• الدعوات: تنتهي بعد ١٤ يومًا وتُحذف بعد ٩٠ يومًا.",
            "• الإشعارات داخل التطبيق: ٩٠ يومًا.",
            "• سجل التدقيق الأمني: ١٣ شهرًا، مع معرّف مستعار بدلًا من هويتك بعد حذف الحساب."
          ]
        },
        {
          "title": "٩. كيف نحمي بياناتك",
          "body": [
            "نستخدم اتصالات مشفّرة (HTTPS)، ونجزّئ كلمات المرور باستخدام Argon2id، ونجعل رموز تسجيل الدخول قصيرة الأجل، ونقصر الوصول إلى البيانات الشخصية على ما يحتاجه كل جزء من النظام، ونسجّل الإجراءات الأمنية في سجل تدقيق لا يقبل التعديل. لا يوجد نظام آمن تمامًا، وإن تأثرت بياناتك بأي اختراق فسنبلغك ونبلغ الجهة المختصة وفق ما يقتضيه النظام."
          ]
        },
        {
          "title": "١٠. حقوقك",
          "body": [
            "بموجب نظام حماية البيانات الشخصية واللائحة العامة لحماية البيانات، يحق لك:",
            "• العلم بكيفية استخدام بياناتك (هذه السياسة)؛",
            "• الوصول إلى بياناتك والحصول على نسخة منها بصيغة مقروءة - استخدم \"تنزيل بياناتي\" في الإعدادات؛",
            "• تصحيح البيانات غير الدقيقة - عدّل ملفك الشخصي في أي وقت؛",
            "• حذف بياناتك - استخدم \"حذف الحساب\" في الإعدادات؛",
            "• سحب موافقتك في أي وقت، دون أن يؤثر ذلك على المعالجة التي سبقت السحب؛",
            "• في الاتحاد الأوروبي، تقييد المعالجة القائمة على المصالح المشروعة أو الاعتراض عليها، والحصول على بياناتك بصيغة قابلة للنقل.",
            "لأي طلب لا يمكنك تنفيذه من التطبيق، راسل support@onelista.com وسنرد خلال ٣٠ يومًا. ويمكنك أيضًا تقديم شكوى إلى الهيئة السعودية للبيانات والذكاء الاصطناعي (سدايا)، أو إلى هيئة حماية البيانات في بلدك داخل الاتحاد الأوروبي."
          ]
        },
        {
          "title": "١١. الأطفال",
          "body": [
            "ليستا غير موجهة للأطفال دون ١٦ عامًا. إن كان عمرك أقل من ١٦ عامًا فاستخدم ليستا بموافقة أحد والديك أو وليّ أمرك. وإن اعتقدت أن طفلًا قدّم لنا بيانات شخصية دون هذه الموافقة، فتواصل معنا وسنحذفها."
          ]
        },
        {
          "title": "١٢. التغييرات على هذه السياسة",
          "body": [
            "إن غيّرنا هذه السياسة فسنحدّث التاريخ أعلاه. وإن كان التغيير جوهريًا فسنبلغك داخل التطبيق أو بالبريد الإلكتروني قبل سريانه، ونطلب موافقتك مجددًا متى اقتضى النظام ذلك."
          ]
        }
      ]
    },
    "terms": {
      "title": "الشروط والأحكام",
      "intro": "هذه الشروط اتفاقية بينك وبين ليستا بشأن استخدامك لليستا على الويب وفي تطبيق الجوال. يُرجى قراءتها مع سياسة الخصوصية.",
      "sections": [
        {
          "title": "١. قبول هذه الشروط",
          "body": [
            "بإنشاء حساب أو استخدام ليستا فإنك توافق على هذه الشروط. وإن لم توافق عليها فلا تستخدم الخدمة."
          ]
        },
        {
          "title": "٢. حسابك",
          "body": [
            "يجب أن يكون عمرك ١٦ عامًا على الأقل أو أن تحصل على موافقة أحد والديك أو وليّ أمرك، وأن تقدّم معلومات صحيحة عند التسجيل. حافظ على سرية كلمة المرور، فأنت مسؤول عن النشاط على حسابك. وأبلغنا على support@onelista.com إن اعتقدت أن شخصًا آخر دخل إليه."
          ]
        },
        {
          "title": "٣. الخدمة",
          "body": [
            "تتيح لك ليستا إنشاء قوائم التسوق ومشاركتها وتخطيط الوجبات وتصدير القوائم، وتُقدَّم الخدمة مجانًا. وقد نضيف ميزات أو نغيّرها أو نزيلها، وسنحاول إبلاغك مسبقًا بالتغييرات المهمة لك."
          ]
        },
        {
          "title": "٤. محتواك",
          "body": [
            "تبقى قوائمك والمحتوى الذي تضيفه ملكًا لك. وتمنحنا الإذن اللازم لتخزين هذا المحتوى ومعالجته وعرضه لك ولمن تشاركهم إياه، لغرض تقديم الخدمة فقط.",
            "أنت مسؤول عمّا تضيفه وتشاركه، فلا تضف محتوى لا يحق لك مشاركته."
          ]
        },
        {
          "title": "٥. المشاركة وروابط المشاركة",
          "body": [
            "عندما تشارك قائمة، يمكن لمن تدعوهم رؤيتها، وتعديل عناصرها إن جعلتهم محررين. ويمكن لأي شخص لديه رابط مشاركة قراءة القائمة حتى تلغي الرابط، لذا لا تشارك الروابط إلا مع من تثق بهم."
          ]
        },
        {
          "title": "٦. الاستخدام المقبول",
          "body": [
            "توافق على ألّا:",
            "• تخالف الأنظمة أو حقوق الآخرين، بما في ذلك عبر المحتوى الذي تشاركه؛",
            "• ترسل رسائل مزعجة أو دعوات غير مرغوب فيها؛",
            "• تحاول الوصول إلى قوائم الآخرين أو حساباتهم، أو تتجاوز ضوابط الأمان أو حدود الطلبات؛",
            "• تعطّل الخدمة أو تُثقلها أو تحاول تفكيكها، أو تستخدم وسائل آلية للوصول إليها إلا عبر التطبيق.",
            "وقد نعلّق أو نغلق الحسابات التي تخالف هذه القواعد."
          ]
        },
        {
          "title": "٧. اقتراحات الذكاء الاصطناعي والقوائم المموّلة",
          "body": [
            "اقتراحات القوائم المولّدة بالذكاء الاصطناعي أفكار فقط وقد تكون ناقصة أو غير دقيقة، فراجعها قبل الاعتماد عليها. ولا يُضاف شيء إلى قائمتك حتى تؤكده.",
            "القوائم المموّلة موسومة بوضوح، وللقراءة فقط، ويقدّمها شركاء. ولسنا مسؤولين عن منتجات الشركاء أو عروضهم."
          ]
        },
        {
          "title": "٨. توفّر الخدمة",
          "body": [
            "نعمل على إبقاء ليستا متاحة وبياناتك آمنة، لكن لا يمكننا ضمان أن تعمل الخدمة دائمًا دون انقطاع أو أخطاء. احتفظ بنسختك من أي شيء مهم، ويمكنك تصدير بياناتك في أي وقت."
          ]
        },
        {
          "title": "٩. المسؤولية",
          "body": [
            "تُقدَّم ليستا \"كما هي\". وبالقدر الذي يسمح به النظام، لا نتحمّل المسؤولية عن الخسائر غير المباشرة أو التبعية، أو عن الخسائر الناتجة عن محتواك أو عن مستخدمين آخرين أو عن أحداث خارجة عن سيطرتنا المعقولة. ولا يحدّ أي شيء في هذه الشروط من مسؤولية لا يجوز تحديدها نظامًا، أو من حقوقك الإلزامية بصفتك مستهلكًا."
          ]
        },
        {
          "title": "١٠. إنهاء الاستخدام",
          "body": [
            "يمكنك التوقف عن استخدام ليستا وحذف حسابك في أي وقت من الإعدادات. وقد نعلّق وصولك أو ننهيه إن خالفت هذه الشروط مخالفة جسيمة أو متكررة، وسنبلغك بالسبب ما لم يمنعنا النظام من ذلك."
          ]
        },
        {
          "title": "١١. النظام الواجب التطبيق",
          "body": [
            "تخضع هذه الشروط لأنظمة المملكة العربية السعودية، وتختص بها المحاكم المختصة في المملكة. وإن كنت تقيم في الاتحاد الأوروبي فتبقى لك حماية قوانين المستهلك الإلزامية في بلدك، ويمكنك رفع دعواك هناك."
          ]
        },
        {
          "title": "١٢. التغييرات والتواصل",
          "body": [
            "قد نحدّث هذه الشروط. وإن كان التغيير جوهريًا فسنبلغك قبل سريانه، وإن واصلت استخدام ليستا بعد ذلك تسري الشروط الجديدة. للاستفسارات: support@onelista.com."
          ]
        }
      ]
    },
    "consent": {
      "title": "خيارات خصوصيتك",
      "body": "تستخدم ليستا ملف تعريف ارتباط واحدًا لإبقائك مسجّلًا، وتخزّن بعض البيانات على جهازك ليعمل التطبيق. وبموافقتك نتذكّر أيضًا تفضيلات اختيارية، مثل طريقة عرض القوائم، بين الزيارات. لا نستخدم ملفات تعريف ارتباط للتتبع أو الإعلانات.",
      "acceptAll": "قبول الكل",
      "essentialOnly": "الضرورية فقط",
      "customize": "اختيار",
      "save": "حفظ الخيارات",
      "learnMore": "اقرأ سياسة الخصوصية",
      "essential": {
        "title": "ضرورية",
        "body": "تبقيك مسجّلًا وتتيح للتطبيق العمل دون اتصال. مفعّلة دائمًا."
      },
      "preferences": {
        "title": "التفضيلات",
        "body": "تتذكّر لغتك ومظهرك وطريقة عرض القوائم والقوائم التي تضيف إليها."
      },
      "saved": "تم حفظ خيارات خصوصيتك"
    },
    "register": {
      "agree": "أوافق على <terms>الشروط والأحكام</terms> وقد اطّلعت على <privacy>سياسة الخصوصية</privacy>.",
      "checkboxLabel": "أوافق على الشروط والأحكام وقد اطّلعت على سياسة الخصوصية",
      "required": "يُرجى قبول الشروط والأحكام لإنشاء حساب"
    }
  },
  "catalogAdmin": {
    "title": "الكتالوج",
    "intro": "نظّم الكتالوج المشترك الذي يختار منه الجميع العناصر. ويمكن أن تنضم إليه الأسماء التي يضيفها كثيرون لأنفسهم، فيجدها الشخص التالي جاهزة.",
    "add": "إضافة عنصر",
    "addTitle": "إضافة عنصر إلى الكتالوج",
    "added": "أُضيف {{name}} إلى الكتالوج",
    "tabs": {
      "suggestions": "مقترحة من المستخدمين",
      "items": "عناصر الكتالوج"
    },
    "suggestionsHint": "عناصر أضافها الناس لأنفسهم (ضمن \"عناصري\")، الأكثر شيوعًا أولًا. ترى كل اسم وعدد من يستخدمه، دون معرفة من هم.",
    "noSuggestions": {
      "title": "لا توجد اقتراحات بعد",
      "body": "عندما يضيف أحدهم عنصرًا خاصًا به، يظهر هنا."
    },
    "usersCount_one": "شخص واحد",
    "usersCount_other": "{{count}} أشخاص",
    "usesCount_one": "في قائمة واحدة",
    "usesCount_other": "في {{count}} قوائم",
    "lastUsed": "آخر استخدام {{date}}",
    "inCatalog": "موجود في الكتالوج باسم {{name}}",
    "promote": "إضافة إلى الكتالوج",
    "promoteTitle": "إضافة «{{name}}» إلى الكتالوج",
    "promoted_one": "أصبح {{name}} في الكتالوج، ويستخدمه الآن عنصر شخص واحد.",
    "promoted_other": "أصبح {{name}} في الكتالوج، وتستخدمه الآن عناصر {{count}} أشخاص.",
    "merge": "دمج",
    "mergeTitle": "دمج «{{name}}»؟",
    "mergeBody": "ستصبح العناصر التي سمّاها {{count}} أشخاص «{{name}}» هي عنصر الكتالوج «{{into}}»، في قوائمهم ومفضلتهم أيضًا. لا يمكن التراجع عن ذلك.",
    "searchPlaceholder": "ابحث بالعربية أو الإنجليزية",
    "searchLabel": "البحث في عناصر الكتالوج",
    "allCategories": "كل الفئات",
    "statusLabel": "الحالة",
    "status": {
      "all": "الكل",
      "active": "نشط",
      "inactive": "غير نشط"
    },
    "noItems": "لا توجد عناصر مطابقة في الكتالوج",
    "editName": "تعديل {{name}}",
    "editTitle": "تعديل عنصر الكتالوج",
    "save": "حفظ",
    "saved": "تم حفظ {{name}}",
    "forbidden": "لا تملك صلاحية الوصول إلى إدارة الكتالوج.",
    "fields": {
      "nameEn": "الاسم بالإنجليزية",
      "nameAr": "الاسم بالعربية",
      "category": "الفئة",
      "unit": "الوحدة الافتراضية",
      "active": "نشط",
      "activeHint": "تُخفى العناصر غير النشطة من التصفح والبحث، لكنها تبقى في القوائم التي تستخدمها.",
      "required": "مطلوب"
    },
    "whoLabel": "أضافه",
    "who": {
      "all": "أي شخص",
      "common": "شخصان أو أكثر"
    },
    "noCommon": "لم يُضف شخصان أو أكثر العنصر نفسه بعد."
  },
  "adminHub": {
    "title": "الإدارة",
    "intro": "أدِر ما يراه الجميع في ليستا.",
    "sponsoredBody": "قوائم تظهر للناس في دولة أو مدينة.",
    "catalogBody": "الكتالوج المشترك والعناصر المقترحة من المستخدمين."
  }
}
